import type { AzureIntegration } from "@p0security/integrations-azure-shared/types";
import type { FrontendInstallContext } from "@p0security/integrations-installer";
import { installedItems } from "@p0security/shared/install/installed";
import { size } from "lodash";
import { Link } from "react-router-dom";

export const appRegistrationPreqMessages = async (
  context: FrontendInstallContext<AzureIntegration>
) => {
  if (!size(installedItems("azure-app", context.config))) {
    return (
      <div>
        Requires installed &quot;
        <Link to={"./azure-app"}>Azure App Registration</Link>
        &quot; component
      </div>
    );
  }

  return undefined;
};
